// extracted by mini-css-extract-plugin
export default {"button_outer":"styles_button_outer__0TF1f","button_inner":"styles_button_inner__H3WVJ","button_text":"styles_button_text__7MlOK"};